/* eslint-disable eqeqeq, max-len, no-nested-ternary  */
import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import classNames from 'classnames';
import { TRootState } from '../../../../reducers';
import {
    serviceNames,
    serviceTypes,
    vehicleTypes
} from '../../../../consts';
import { TRoleData, TServiceKey, TServicesStructure } from '../../../../types';
import { updateField } from '../../../../actions/BookingRequest';


const defaultSkillsValues = {
    'own_vehicle': {
        icon: 'icon-user',
        text: 'Driver only',
    },
    'minimum_delivery_box': {
        icon: 'icon-close',
        text: 'we provide vehicle',
    },
};

type TSelectedRoleIconProps = {
    service: TServiceKey;
    selectedService: TServiceKey;
    servicesStructure: TServicesStructure;
}

function SelectedRoleIcon({
    service,
    selectedService,
    servicesStructure,
}: TSelectedRoleIconProps) {
     const serviceName =
        // @ts-ignore
         serviceNames[Object.keys(serviceTypes).find(key  => serviceTypes[key] === selectedService)];
     const activeClass = service === selectedService ? ' active' : '';

    return (
        <div className="role-item">
            <div className={`item-circle-wrapper${activeClass}`}>
                <i className={`icon ${servicesStructure[selectedService].icon_name}${activeClass}`} />
            </div>
            <p className={`role-item-name${activeClass}`}>{serviceName}</p>
        </div>
    );
}


type TSelectedRoleDetailsIconProps = {
    service: TServiceKey;
    selectedService: TServiceKey;
    roleData: TRoleData[keyof TRoleData];
    servicesStructure: TServicesStructure;
}

function SelectedRoleDetailsIcon({
    service,
    selectedService,
    roleData,
    servicesStructure,
}: TSelectedRoleDetailsIconProps) {

    const activeClass = service === selectedService ? ' active' : '';

    const serviceStructure = servicesStructure[selectedService];
    const fieldName = serviceStructure.role_field_name;
    const filterName = serviceStructure.role_filter_name;
    // @ts-ignore-line
    const selectedRole = roleData[fieldName];
    const roleStructure = serviceStructure[filterName][selectedRole];

    const skills = Object.entries(roleData).filter(([skill]) =>
        roleStructure.hasOwnProperty(skill)
    ).map(([skill, value]) => [skill, value]);

    if (selectedRole == vehicleTypes.VAN && !skills.filter(skill => skill[1] == 1).length) {
        skills.push(['small_van', 1]);
    }

    return (
        <>
            <div className="role-item">
                <div className={`item-circle-wrapper role-details-item ${activeClass}`}>
                    <i className={`icon ${roleStructure.icon_name}${activeClass}`}/>
                </div>
                <p className={`role-item-name role-details-item-name${activeClass}`}>{roleStructure.label}</p>
            </div>
            <div className="role-extra-details">
                {skills.map(skill => {
                    const [skillName, value] = skill;

                    let skillIcon;
                    let skillText;
                    const skillDetails = roleStructure[skillName].true;

                    if (skillName === 'minimum_delivery_box') {
                        skillIcon = skillDetails ? skillDetails[value].icon_name : roleStructure.icon_name;
                        skillText =  value == 4 ? 'Pizza box' : 'Small box';
                    } else if (skillName === 'own_vehicle' && value == 0) {
                        skillIcon = defaultSkillsValues[skillName].icon;
                        skillText = defaultSkillsValues[skillName].text;
                    } else if (roleStructure && roleStructure.hasOwnProperty(skillName) && value != 0) {
                        skillIcon = skillDetails ? skillDetails.icon_name : roleStructure.icon_name;
                        skillText = skillDetails ? skillDetails.label : roleStructure.label;
                    } else {
                        skillIcon = null;
                    }

                    if (skillIcon) {
                        return (
                            <div key={skillName} className="role-item">
                                <div className={`item-circle-wrapper role-details-item${activeClass}`}>
                                    <i className={`icon ${skillIcon}${activeClass}`}/>
                                </div>
                                <p className={`role-item-name role-details-item-name${activeClass}`}>{skillText}</p>
                            </div>
                        );
                    }
                    return '';
                })}
            </div>
        </>
    );
}


type TAgentMultiServiceCardProps = {
    className: string;
    selectedServices: TServiceKey[];
    handleSetSelectedServices: (selectedServices: TServiceKey[]) => void;
    mode: string;
}

export function AgentMultiServiceCard({
    className,
    selectedServices,
    handleSetSelectedServices,
    mode,
}: TAgentMultiServiceCardProps) {

    const dispatch = useDispatch();
    const { roleData, service } = useSelector(
        (state: TRootState) => ({
            roleData: state.requestData.roleData,
            service: state.requestData.bookingRequest.service,
        }),
    );

    const { servicesStructure } = useSelector((state: TRootState) => state);

    const handleDeselectService = (deselectedService: TServiceKey) => {
        const newSelectedServices =
            selectedServices.filter(selectedService => selectedService !== deselectedService);
        handleSetSelectedServices(newSelectedServices);

        if (deselectedService === service && newSelectedServices.length) {
            dispatch(updateField('service', newSelectedServices[0]));
        }
    };

    const handleMouseEnter = (event: any) => {
        if (mode !== 'edit') {
            event.target.className = 'icon icon-remove-circle-11 red';
        }
    };

    const handleMouseLeave = (event: any) => {
        if (mode !== 'edit') {
            event.target.className = 'icon icon-remove-circle-1 red';
        }
    };

    return (
        <div className={classNames('card card-role card-role-main', className)}>
            <div className="card-content">
                <p className="card-title">Selected services</p>
                <div className="selected-services">
                    {selectedServices.length > 0 && selectedServices.map(selectedService=>
                        <div
                            className="selected-service"
                            key={selectedService}
                        >
                            <button
                                type="button"
                                onClick={() => handleDeselectService(selectedService)}
                                disabled={mode === 'edit'}
                            >
                                <i
                                    className={`icon icon-remove-circle-1 ${mode !== 'edit' ? 'red' : ''}`}
                                    onMouseEnter={handleMouseEnter}
                                    onMouseLeave={handleMouseLeave}
                                />
                            </button>
                            <div
                                className="role-items"
                                onClick={() => dispatch(updateField('service', selectedService))}
                            >
                                <SelectedRoleIcon
                                    service={service}
                                    selectedService={selectedService}
                                    servicesStructure={servicesStructure}
                                />
                                <SelectedRoleDetailsIcon
                                    service={service}
                                    selectedService={selectedService}
                                    roleData={roleData[selectedService]}
                                    servicesStructure={servicesStructure}
                                />
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </div>
    );
}
